import {useEffect, useRef, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";

import {userProfileService} from "../../service/userProfile/userProfile.service";
import {SENSITIVE_SCOPE} from "../../config/securityContext";

import Spinner from "../../helpers/spinner";
import DynamicAlert from "../../helpers/dynamicAlert";
import {useNavigate} from "react-router-dom";

export default function PostLoginHandler({pendingOperation, onComplete}) {
    const {isAuthenticated} = useAuth0();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [alert, setAlert] = useState(null);
    const hasRunRef = useRef(false);

    useEffect(() => {
        if (!isAuthenticated || hasRunRef.current) return;
        hasRunRef.current = true;

        const run = async () => {
            sessionStorage.removeItem("pendingOperation");

            if (!pendingOperation) {
                onComplete();
                return;
            }

            try {
                setIsLoading(true);
                const scope = pendingOperation.scope;
                switch (scope) {
                    case SENSITIVE_SCOPE.CHANGE_PASSWORD: {
                        const res = await userProfileService.resetPasswordTicket(scope);
                        if (res?.ticket) {
                            window.location.href = res.ticket;
                            return;
                        }
                        // No ticket: return to the settings page instead of a blank screen.
                        onComplete();
                        break;
                    }

                    case SENSITIVE_SCOPE.DELETE_ACCOUNT: {
                        const res = await userProfileService.deleteProfile(scope);

                        navigate("/delete/profile", {
                            replace: true,
                            state: {
                                action: res?.statusCode === "500" ? "deletion-failed" : "deleted-account"
                            }
                        });
                        break;
                    }

                    default:
                        onComplete();
                }
            } catch (error) {
                console.error("PostLoginHandler error:", error);
                setAlert({
                    id: Date.now(),
                    type: "danger",
                    msg: "Something went wrong while processing your request.",
                });
            } finally {
                setIsLoading(false);
            }
        };

        run();
    }, [isAuthenticated, pendingOperation, onComplete, navigate]);

    return (
        <>
            <DynamicAlert alert={alert}/>
            {isLoading && <Spinner/>}
        </>
    );
}
